import { render, staticRenderFns } from "./ETREmail.vue?vue&type=template&id=5a97375c&"
import script from "./ETREmail.vue?vue&type=script&lang=js&"
export * from "./ETREmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports